<script>

export default {
  reactiveProvide: {
    name: 'Control',

    include: [
      'handleChange',
      'handleInput',
      'handleReset',
      'handleElementPropertyChange',
      'handleElementPropertyInput',
      'handleElementPropertyReset',
      'handleUiChange',
      'handleBreakpointChange',

      'ui',
      'properties',
      'computedProperties',
      'breakpoint',
      'resettable'
    ]
  },

  props: {
    breakpoint: String,
    ui: Object,
    properties: Object,
    computedProperties: Object,
    resettable: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleElementPropertyChange (event) {
      this.$emit('elementpropertychange', event)
    },

    handleElementPropertyInput (event) {
      this.$emit('elementpropertyinput', event)
    },

    handleElementPropertyReset (event) {
     this.$emit('elementpropertyreset', event)
    },

    handleUiChange (event) {
      this.$emit('uichange', event)
    },

    handleBreakpointChange (event) {
      this.$emit('breakpointchange', event)
    }
  },

  computed: {
    /* TODO: deprecated */
    handleInput () { return this.handleElementPropertyInput },

    /* TODO: deprecated */
    handleChange () { return this.handleElementPropertyChange },

    /* TODO: deprecated */
    handleReset () { return this.handleElementPropertyReset }
  },

  render () {
    return this.$slots.default
  }
}

</script>
